import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { appConfig } from 'config';
import { get } from 'lodash';
import {
  EuiHeaderSectionItemButton,
  EuiPopover,
  EuiPopoverFooter,
  EuiTextColor,
  EuiAvatar,
  EuiSelectable,
} from 'stable-eui';

const HeaderSpacesMenu = () => {
  const spaces = [
    {
      label: "B-Logistics",
      prepend: (
        <EuiAvatar
          type="space"
          initials="BL"
          initialsLength={2}
          name={'B-Logistics'}
          style={{ color: '#ffd834', backgroundColor: '#3e3e20' }}
          size="s"
        />
      ),
      checked: 'on',
    },
  ];

  const [selectedSpace, setSelectedSpace] = useState(
    spaces.filter((option) => option.checked)[0]
  );
  const [isOpen, setIsOpen] = useState(false);

  const isListExtended = () => {
    return spaces.length > 4;
  };

  const onMenuButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const closePopover = () => {
    setIsOpen(false);
  };

  const onChange = (options) => {
    const newSelectedSpace = options.filter((option) => option.checked)[0];
    setSelectedSpace(newSelectedSpace);
    setIsOpen(false);
  };

  const button = (
    <EuiHeaderSectionItemButton
      aria-controls="headerSpacesMenuList"
      aria-expanded={isOpen}
      aria-haspopup="true"
      aria-label="Apps menu"
      onClick={onMenuButtonClick}
    >
      {selectedSpace.prepend}
    </EuiHeaderSectionItemButton>
  );

  return (
    <EuiPopover
      id="headerSpacesMenu"
      // ownFocus
      button={button}
      isOpen={isOpen}
      anchorPosition="downLeft"
      closePopover={closePopover}
      panelPaddingSize="none"
    >
      <EuiSelectable
        searchable={isListExtended()}
        searchProps={{
          placeholder: 'Find a space',
          compressed: true,
        }}
        options={spaces}
        singleSelection="always"
        style={{ width: 300 }}
        onChange={onChange}
        listProps={{
          rowHeight: 40,
          showIcons: false,
        }}
      >
        {(list) => <>{list}</>}
      </EuiSelectable>
      <EuiPopoverFooter style={{ padding: '8px', textAlign: 'center' }}>
        <EuiTextColor color="subdued">
          <span style={{ padding: '4px 12px', backgroundColor: '#006de433', color: '#343741', borderRadius: '4px' }}>{get(appConfig, 'release_date', 'v2.0.1')}</span>
        </EuiTextColor>
      </EuiPopoverFooter>
    </EuiPopover>
  );
};

export default withRouter(HeaderSpacesMenu);
